import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { AxiosError } from "axios";

export function useDeleteUserPhoto(options?: UseMutationOptions<void, AxiosError<{ message: string }>, void>) {
  return useMutation({
    mutationKey: ["delete-user-photo"],
    mutationFn: async () => {
      await $api.delete("/user/photo");
    },
    ...options
  });
}
